import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export interface UserState {}

export const UserAdapter = createEntityAdapter<UserState>();

const initialState: UserState = {};

const userSlice = createSlice({
  name: 'user',
  initialState: UserAdapter.getInitialState(initialState),
  reducers: {},
});

// export const {} = signInSlice.actions;
export default userSlice.reducer;
